import 'react-notifications/lib/notifications.css';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReviewTable from '../review/ReviewTable/ReviewTable';

class ReviewDashboard extends Component {
	async componentDidMount() {
		document.title = 'Reviews | Chekkit Enterprise';
	}

	render() {
		return <ReviewTable />;
	}
}

function mapStateToProps(state) {
	return { error: state.error };
}

export default connect(mapStateToProps)(ReviewDashboard);



// WEBPACK FOOTER //
// ./src/components/dashboards/ReviewDashboard.js